import React, { useEffect, useRef } from "react";

import "./index.sass";

interface FrameTVProps {
  scrollTop?: boolean;
  children?: React.ReactNode;
  scrollPosition?: number | null;
  scrollDisabled?: boolean;
}

const FrameTV = ({ children, scrollTop = false, scrollPosition = null, scrollDisabled = false }: FrameTVProps) => {
  const tvRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollDisabled) {
      if (scrollTop && tvRef.current) {
        tvRef.current.scrollTop = 0;
        tvRef.current.style.overflow = "hidden";
      } else if (tvRef.current) tvRef.current.style.overflow = "";
    }
  }, [scrollTop, children, scrollDisabled]);

  useEffect(() => {
    if (!scrollDisabled) if (scrollPosition !== null && tvRef.current) tvRef.current.scrollTop = scrollPosition;
  }, [scrollPosition, scrollDisabled]);

  useEffect(() => {
    if (tvRef.current && scrollDisabled) {
      tvRef.current.scrollTop = 0;
      tvRef.current.style.overflow = "hidden";
    }
  }, [scrollDisabled]);

  return (
    <div className="frame-tv">
      <div className="frame-tv-screen" ref={tvRef}>
        {children}
      </div>
    </div>
  );
};

export default FrameTV;
